import {
  ActionType,
  IClientPatchTask,
  IGetTaskClientProducts,
  IMoveTask,
  IPostClientTask,
  IPostClientTaskConnectProduct,
  IPostTask,
  ISetTaskFilter,
  ISetTaskGroupState,
  ITask,
  IUpdateFiltersByQuery,
} from './model'
import { Action, ActionCallback, ActionOptionalCallback, IValidationCallback } from '../model'

export const getCategoriesAction = () => ({
  type: ActionType.GET_CATEGORIES,
})

export const getStatusesAction = () => ({
  type: ActionType.GET_STATUSES,
})

export const getTaskClientProductsAction = (payload: IGetTaskClientProducts): Action<IGetTaskClientProducts> => ({
  type: ActionType.GET_TASK_CLIENT_PRODUCTS,
  payload,
})

export const getClientsAction = () => ({
  type: ActionType.GET_ACCOUNT_CLIENTS,
})

export const getAccountManagersTasksAction = () => ({
  type: ActionType.GET_ACCOUNT_MANAGERS_TASKS,
})

export const getClientsTasksAction = () => ({
  type: ActionType.GET_CLIENTS_TASKS,
})

export const getClientManagersTasksAction = () => ({
  type: ActionType.GET_CLIENT_MANAGERS_TASKS,
})

export const getDoneTasksAction = () => ({
  type: ActionType.GET_DONE_TASKS,
})

export const getManagersDoneTasksAction = () => ({
  type: ActionType.GET_MANAGERS_DONE_TASKS,
})

export const getAllTasksAction = () => ({
  type: ActionType.GET_ALL_TASKS,
})

export const addTaskFilter = (payload: ISetTaskFilter): Action<ISetTaskFilter> => ({
  type: ActionType.ADD_TASK_FILTER,
  payload,
})

export const removeTaskFilter = (payload: ISetTaskFilter): Action<ISetTaskFilter> => ({
  type: ActionType.REMOVE_TASK_FILTER,
  payload,
})

export const updateFiltersByQueryAction = (payload: IUpdateFiltersByQuery): Action<IUpdateFiltersByQuery> => ({
  type: ActionType.UPDATE_FILTERS_BY_QUERY,
  payload,
})

export const clearAllTaskFilters = () => ({
  type: ActionType.CLEAR_ALL_TASK_FILTERS,
})

export const setCollapsedTaskGroup = (payload: ISetTaskGroupState): Action<ISetTaskGroupState> => ({
  type: ActionType.SET_COLLAPSED_TASK_GROUP,
  payload,
})

export const setFullListTaskGroup = (payload: ISetTaskGroupState): Action<ISetTaskGroupState> => ({
  type: ActionType.SET_FULL_LIST_TASK_GROUP,
  payload,
})

export const moveTaskAction = (payload: IMoveTask): Action => ({
  type: ActionType.MOVE_TASK,
  payload,
})

export const archiveTaskAction = (
  payload: { id: number },
  callback: IValidationCallback
): ActionCallback<{ id: number }> => ({
  type: ActionType.ARCHIVE_TASK,
  payload,
  callback,
})

export const changeActiveTaskAction = (
  payload: { id: number },
  callback?: IValidationCallback
): ActionOptionalCallback<{ id: number }> => ({
  type: ActionType.CHANGE_ACTIVE_TASK,
  payload,
  callback,
})

export const getTaskAction = (payload: {
  id: number | string
  refreshCurrentTask?: boolean
}): Action<{ id: number | string }> => ({
  type: ActionType.GET_TASK,
  payload,
})

export const postTaskAction = (
  payload: IPostTask | IPostClientTask,
  callback: IValidationCallback
): ActionCallback<IPostTask | IPostClientTask> => ({
  type: ActionType.POST_TASK,
  payload,
  callback,
})

export const postTaskConnectProductAction = (
  payload: IPostClientTaskConnectProduct,
  callback: IValidationCallback
): ActionCallback<IPostClientTaskConnectProduct> => ({
  type: ActionType.POST_TASK_CONNECT_PRODUCT,
  payload,
  callback,
})

export const postTaskConnectProductCabinetAction = (
  payload: IPostClientTaskConnectProduct,
  callback: IValidationCallback
): ActionCallback<IPostClientTaskConnectProduct> => ({
  type: ActionType.POST_TASK_CONNECT_PRODUCT_CABINET,
  payload,
  callback,
})

export const getTaskFileAction = (
  payload: { id: number },
  callback: IValidationCallback
): ActionCallback<{ id: number }> => ({
  type: ActionType.GET_TASK_FILE,
  payload,
  callback,
})

export const patchTaskAction = (
  payload: IPostTask | IClientPatchTask,
  callback?: IValidationCallback
): ActionOptionalCallback<IPostTask | IClientPatchTask> => ({
  type: ActionType.PATCH_TASK,
  payload,
  callback,
})

export const setTaskAction = (payload: ITask | null): Action<ITask | null> => ({
  type: ActionType.SET_TASK,
  payload,
})

export const stopWatchTasksAction = () => ({
  type: ActionType.STOP_WATCH_TASKS,
})

export const startWatchTasksAction = () => ({
  type: ActionType.START_WATCH_TASKS,
})
